import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { merge } from 'lodash-es';
import zIndex from '../../foundations/zIndex.module.scss';
import { useIsInBottomSheet } from '../BottomSheet';
import { useDevice } from '../Device';
import { useOverlayContext } from '../OverlayContext';
import { BaseTextField } from '../TextField/BaseTextField/BaseTextField';
import { MobileSelect, SelectOptionsBottomSheet } from './MobileSelect';
// See note on BaseTextField — forwardRef + MUI types collapses BiProps' discriminated union.
const SelectImpl = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { mobile, menuAsPopover } = props, restProps = _object_without_properties(props, [
        "mobile",
        "menuAsPopover"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const { pushBottomSheetPage } = useOverlayContext();
    if (!menuAsPopover && (isInBottomSheet || !(mobile === null || mobile === void 0 ? void 0 : mobile.renderAsCard) && isMobileDevice)) {
        return /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, restProps), {
            ref: ref,
            select: true,
            SelectProps: merge(restProps.SelectProps, {
                open: false,
                onOpen: ()=>{
                    pushBottomSheetPage({
                        content: /*#__PURE__*/ _jsx(SelectOptionsBottomSheet, _object_spread({
                            saveOnSelect: true
                        }, restProps))
                    });
                }
            })
        }));
    } else if ((mobile === null || mobile === void 0 ? void 0 : mobile.renderAsCard) && isMobileDevice) {
        return /*#__PURE__*/ _jsx(MobileSelect, _object_spread_props(_object_spread({}, restProps), {
            mobile: mobile,
            ref: ref
        }));
    } else {
        // Inside a bottom sheet the default menu popover paints behind the sheet — lift only its
        // z-index (deep-merged so BaseTextField's own MenuProps, incl. the backdrop testId, survive).
        const selectProps = menuAsPopover && isInBottomSheet ? merge({}, restProps.SelectProps, {
            MenuProps: {
                style: {
                    zIndex: Number(zIndex.bottomSheet) + 1
                }
            }
        }) : restProps.SelectProps;
        return /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, restProps), {
            SelectProps: selectProps,
            ref: ref,
            select: true
        }));
    }
});
export const Select = SelectImpl;
